import { MARQUEE_ITEMS } from "@/data/site";

const Row = ({ ariaHidden }) => (
  <div
    aria-hidden={ariaHidden || undefined}
    className="flex shrink-0 items-center"
  >
    {MARQUEE_ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`font-display text-2xl font-black uppercase tracking-wide sm:text-4xl ${
            i % 2 === 0
              ? "text-white"
              : "text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.35)]"
          }`}
        >
          {item}
        </span>
        <span className="mx-6 h-2 w-2 rotate-45 bg-[#F0B429] sm:mx-10" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      data-testid="marquee-strip"
      className="marquee-wrap relative overflow-hidden border-y border-white/10 bg-[#0D111A] py-5 sm:py-6"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row ariaHidden />
      </div>
    </section>
  );
}
